import type { User } from "@/users/types";
import { computed, toValue, type MaybeRefOrGetter } from "vue";
import type { Canvass } from "./types";

export function useParticipation(
  canvass: MaybeRefOrGetter<Canvass>,
  users: MaybeRefOrGetter<Array<User> | undefined>,
) {
  const sortedUsers = computed(() => {
    const currentUsers = toValue(users);

    if (currentUsers === undefined) return [];
    return currentUsers.toSorted((a, b) => a.name.localeCompare(b.name));
  });

  const assignedUsers = computed(() =>
    sortedUsers.value.filter((user) =>
      toValue(canvass).participantIds.includes(user.id),
    ),
  );

  const unassignedUsers = computed(() =>
    sortedUsers.value.filter((user) => !assignedUsers.value.includes(user)),
  );

  return {
    assignedUsers,
    unassignedUsers,
  };
}
